import type { FetchByQueryResult, Segment } from "mobx-repository";
import { prop } from "ramda";
import type {
    PageInfo,
    PreOpsAnswerCreate,
    PreOpsAnswersApi,
    PreOpsAnswersListPreOpsAnswersRequest,
    PreOpsAnswer,
    PreOpsAnswerSortKey,
} from "../../api";
import type { ApiResource } from "../../utils/elofleet-repository";
import { ElofleetRepository } from "../../utils/elofleet-repository";
import type { UUID } from "../../utils/uuid";

export type PreOpsAnswersQuery = Omit<PreOpsAnswersListPreOpsAnswersRequest, "page">;

export interface PreOpsAnswersApiResource extends ApiResource {
    entity: PreOpsAnswer;
    query: PreOpsAnswersQuery;
    update: unknown;
    create: PreOpsAnswerCreate;
    sortKey: PreOpsAnswerSortKey;
}

export class RepositoryPreOpsAnswers extends ElofleetRepository<PreOpsAnswersApiResource> {
    constructor(private readonly preOpsAnswersApi: PreOpsAnswersApi) {
        super();
    }

    private metadataRequest: Promise<PageInfo> | undefined;

    protected async fetchById(answerId: UUID): Promise<PreOpsAnswer | undefined> {
        return await this.preOpsAnswersApi.preOpsAnswersReadPreOpsAnswer({
            answerId,
        });
    }

    protected extractId = prop("id");

    protected async fetchByQuery(
        query: PreOpsAnswersQuery,
        pagination: Segment,
    ): Promise<FetchByQueryResult<PreOpsAnswer>> {
        const page = pagination.offset / this.defaultCount;
        const entities = await this.preOpsAnswersApi.preOpsAnswersListPreOpsAnswers({
            ...query,
            page,
        });
        return { entities };
    }

    public async waitForIdle(): Promise<void> {
        await Promise.all([super.waitForIdle(), this.metadataRequest]);
    }

    public fetchMetadata(query: PreOpsAnswersQuery): Promise<PageInfo> {
        this.metadataRequest = this.preOpsAnswersApi.preOpsAnswersListPreOpsAnswersMetadata(query);
        return this.metadataRequest;
    }

    public update(_id: string, _update: never): Promise<PreOpsAnswer> {
        throw new Error("Method not implemented.");
    }
    public create(_update: PreOpsAnswerCreate): Promise<PreOpsAnswer> {
        throw new Error("Method not implemented.");
    }
    public delete(..._ids: string[]): Promise<void> {
        throw new Error("Method not implemented.");
    }
}
